/* eslint-disable import/export */

import Root from './pages/Root';

import * as asite from './store/features/asite';

export default Root;

const ducks = { asite: { ...asite } };

export { ducks };
